import { GET_OWNERS, GET_OWNERS_RESPONSE, RESET } from "./actions";

const initialState = {
  isLoading: false,
  error: null,
  data: {
    ownersList: {
      items: [],
    },
    owner: null,
    searchQuery: null,
    range: { start: 0, end: 25 },
  },
};

// State
export default (state = initialState, action) => {
  var data = state.data;
  switch (action.type) {
    case RESET:
      return Object.assign({}, initialState);
    case GET_OWNERS:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case GET_OWNERS_RESPONSE:
      data.ownersList.items = action.owners;
      return {
        ...state,
        data: data,
        error: action.error,
        isLoading: false,
      };
    default:
      return {
        ...state,
      };
  }
};
